module.exports = __webpack_public_path__ + "img/vue1-renfort_blanc.a5f19415.png";